// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"e142c35f","298":"b6cafb75","422":"392c6ce9"}[chunkId] + ".chunk.js";
};